<template>
  <div class="py-2 px-2 bg-secondary d-inline-block rounded-3">
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="text-center w-100">
        <span class="text-white ms-3 fw-semibold text-break">{{ content }}</span>
      </div>
      <ButtonView type="normal" color="primary" class="text-uppercase ms-3" style="white-space: nowrap" @click="copyToClipboard()">
        {{ translate("copy") }}
      </ButtonView>
    </div>
  </div>
</template>

<script>
import {ButtonView, toasts} from "@/niftybit";
import localization from "@/localization";

export default {
  name: "CopyButton",
  components: {ButtonView},
  emits: ["copy"],
  props: {
    content: String
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.content);
      toasts.create({
        color: "info",
        icon: "fas fa-info-circle text-info",
        content: localization.translate("copied_to_clipboard")
      });
      this.$emit('copy');
    }
  }
}
</script>

<style scoped>

</style>